/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import config from 'js/app/config';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';

import _t from 'i18n!nls/grading';

const styles = {
  error: () => css`
    margin-top: var(--cds-spacing-400);
  `,
};

// Component for grade override error notifications
// isApplyOverrideDialog (required): false = deleteOverrideDialog
const ErrorNotification: React.FC<{ isApplyOverrideDialog: boolean }> = ({ isApplyOverrideDialog }) => {
  const { mutations } = useContext(SGAPageContext);

  if (!mutations) {
    return null;
  }

  let errorText;
  let errorTitle;
  let errorDetails;

  if (isApplyOverrideDialog && mutations.applyGradeOverrideStatus.error) {
    errorText = _t('Something went wrong while applying grade override. Please try again.');
    errorTitle = _t('Unable to apply grade override.');
    errorDetails = mutations?.applyGradeOverrideStatus?.error.message;
  } else if (!isApplyOverrideDialog && mutations.deleteGradeOverrideStatus.error) {
    errorText = _t('Something went wrong while deleting grade override. Please try again.');
    errorTitle = _t('Unable to delete grade override.');
    errorDetails = mutations?.deleteGradeOverrideStatus?.error.message;
  }

  return errorText ? (
    <InlineNotification severity="error" title={errorTitle} css={styles.error}>
      <React.Fragment>
        {errorText}
        {config.environment === 'development' && (
          <Typography2 component="div" variant="bodySecondary">
            Details: {errorDetails}
          </Typography2>
        )}
      </React.Fragment>
    </InlineNotification>
  ) : null;
};

export default ErrorNotification;
